import { z } from 'zod';

export enum IntegrationsType {
  TWO_WAY = 'two_way',
  ONE_WAY = 'one_way',
  VIRTUAL = 'virtual',
}

export enum IntegrationsCategory {
  DSP = 'dsp',
  DMP = 'dmp',
  AD_SERVER = 'ad_server',
  AD_NETWORK = 'ad_network',
  PUBLISHER = 'publisher',
  BRAND_SAFETY = 'brand_safety',
  WEB_ANALYTICS = 'web_analytics',
  INTEGRATED = 'integrated',
}

const IntegrationType = z.enum(['two_way', 'one_way', 'virtual'] as const);

const IntegrationCategory = z.enum([
  'integrated',
  'publisher',
  'dsp',
  'ad_network',
  'ad_server',
  'dmp',
  'brand_safety',
  'web_analytics',
] as const);

export const GetPlatformsResponse = z.array(
  z.object({
    id: z.number(),
    platform: z.string(),
    label: z.string(),
    channels: z.array(z.string()),
    description: z.string(),
    category: IntegrationCategory,
    logo: z.string().or(z.null()),
    type: IntegrationType,
    isDeleted: z.boolean(),
    isIntegrated: z.boolean().or(z.null()),
    integrationsCount: z.number().or(z.null()),
    isOmni: z.union([z.boolean(), z.undefined()]),
    typeForAdd: z.string().optional(),
  }),
);

export type PlatformsResponse = z.infer<typeof GetPlatformsResponse>;
export type Platform = PlatformsResponse[number];
